import React from "react";
import style from "../woundAssessment.module.scss";
import { getHistoryCauseText } from "../../../../utils/getHistoryCauseText";
import { fullMonthFormatDate } from "../../../../utils";
import { Button } from "../../../primary";
import { AssessmentRow } from "./AssessmentRow";
import { Spinner } from "../../../secondary/Loader/Spinner";

export const WoundGroup = ({
  item,
  parentIndex,
  patientData,
  historyCause,
  consolidatePdfLoading,
  selectedIdsByWound,
  getAllMatchingChildIds,
  handleSelectAll,
  handleSelectOne,
  handleDownloadConsolidatePDF,
  woundProgress,
  assessmentStageGetter,
  detaileView,
  pdfmodalopen,
  setHistoryId,
  hasAccess,
  clickThreeDots,
  openTooltip,
  threeDotPanelClick,
  threeDotMenuProps,
}) => (
  <div className={style.admission_status_space}>
    <div className={`pl-4 ${style.sub_heading}`}>{`${item.woundTitle}`}</div>
    <div className={`pl-4 pr-4 mb-2 mt-1 pt-1 ${style.admission_status}`}>
      History/Cause: <span>{getHistoryCauseText(item, historyCause)}</span>
    </div>
    <div className={`pl-4 pr-4 mb-2 pb-1 mt-1 ${style.admission_status}`}>
      {`Admission Date: ${fullMonthFormatDate(item.admissionDate)} ${
        item?.dischargeDate ? `| Discharged Date: ${fullMonthFormatDate(item.dischargeDate)}` : ""
      }`}
    </div>
    <div className={`pl-4 pr-4 mb-2 pb-1 mt-1 ${style.admission_status}`}>
      {patientData?.isConsolidatedPdfEnable === 1 && selectedIdsByWound[parentIndex]?.length > 0 && (
        <Button
          type="button"
          classes={{ className: `btn pr-3 pl-3 ${style.btn_custom_download}` }}
          onClick={() => handleDownloadConsolidatePDF(item.woundTitle, selectedIdsByWound[parentIndex])}
        >
          Download Consolidated PDF
        </Button>
      )}
      {consolidatePdfLoading && (
        <div className={style.info_message}>
          <div>
            Creating your PDF report... <span>This won't take long</span>{" "}
            <Spinner className={style.loader_fix} inline />
          </div>
        </div>
      )}
    </div>
    <table className="w-100" cellPadding="0" cellSpacing="0">
      <thead>
        <tr className={style.complete_th}>
          {patientData?.isConsolidatedPdfEnable === 1 && (
            <th>
              <input
                type="checkbox"
                className={`mt-2 ${style.consolidate_checkbox}`}
                checked={selectedIdsByWound[parentIndex]?.length === getAllMatchingChildIds(item).length && getAllMatchingChildIds(item).length > 0}
                onClick={() => handleSelectAll(parentIndex, item)}
              />
            </th>
          )}
          <th>Wound</th>
          <th>Record type</th>
          <th>Photo taken on</th>
          <th>Wound progress</th>
          <th>Trend</th>
          <th>Workflow status</th>
          <th>Unable to assess wound</th>
          <th>View/Download PDF</th>
          {hasAccess && <th></th>}
        </tr>
      </thead>
      <tbody>
        {item?.assessments?.map((history, index) => (
          <AssessmentRow
            key={history?.id}
            history={history}
            index={index}
            woundTitle={item?.woundTitle}
            isConsolidatedPdfEnable={patientData?.isConsolidatedPdfEnable}
            selectedIdsByWound={selectedIdsByWound}
            parentIndex={parentIndex}
            handleSelectOne={handleSelectOne}
            woundProgress={woundProgress}
            assessmentStageGetter={assessmentStageGetter}
            detaileView={detaileView}
            pdfmodalopen={pdfmodalopen}
            setHistoryId={setHistoryId}
            hasAccess={hasAccess}
            clickThreeDots={clickThreeDots}
            openTooltip={openTooltip}
            threeDotPanelClick={threeDotPanelClick}
            threeDotMenuProps={threeDotMenuProps}
          />
        ))}
      </tbody>
    </table>
  </div>
);
